import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { api } from "@app/api/carApi.manual";
import { thesysChatApi } from "@app/features/thesysChat/api/thesysChatApi";
import { planGuideApi } from "@app/features/planGuide/api/planGuideApi";
import { pendingSliceReducer } from "./pendingSlice";
import { toastReducer } from "./toastSlice";
import { controlPanelSliceReducer } from "./controlPanelSlice";
import { authReducer } from "./authSlice";
import { drawerReducer } from "./drawerSlice";
import { dialogReducer } from "./dialogSlice";
import { errorMiddleware } from "./errorMiddleware";
import { listenerMiddleware } from "./listenerMiddleware";
import { settingsSliceReducer } from "./settingsSlice";
import { registerDispatch } from "@app/api/getAccessToken";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    pending: pendingSliceReducer,
    api: api.reducer,
    thesysChatApi: thesysChatApi.reducer,
    planGuideApi: planGuideApi.reducer,
    toast: toastReducer,
    controlPanel: controlPanelSliceReducer,
    drawer: drawerReducer,
    dialog: dialogReducer,
    settings: settingsSliceReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      api.middleware, 
      thesysChatApi.middleware,
      planGuideApi.middleware,
      errorMiddleware, 
      listenerMiddleware.middleware
    ),
});

setupListeners(store.dispatch);

registerDispatch(store.dispatch);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
